/**
 *  Created by piotr@revisual.io on 04/08/2025
 */
import appConfig from "../../../../appConfig";
import classNames from "classnames";
import { useMemo } from "react";

const introCopy = (
  <span>
    We're excited to help you create impactful visuals. A few quick questions
    will help us tailor your Revisual experience to your needs<sup>1</sup>.
  </span>
);

const industries = [
  "Business",
  "Education",
  "Entertainment",
  "Healthcare",
  "Hospitality",
  "Restaurants, Bars & Cafés",
  "Promoters / Event Planners",
  "Public Sector / Government",
  "Religious / Faith-Based",
  "Nonprofit",
  "Other",
];

const roles = [
  {
    label: "Leadership & Strategy",
    options: ["Founder / CEO", "Director", "Project Manager", "Strategy Lead"],
  },
  {
    label: "Creative & Marketing",
    options: [
      "Graphic Designer",
      "Marketing Manager",
      "Content Creator",
      "Social Media Manager",
    ],
  },
  {
    label: "Operations & Admin",
    options: [
      "Administrator",
      "Operations Manager",
      "HR or Team Support",
      "Executive Assistant",
    ],
  },
  {
    label: "Technical",
    options: ["Developer", "Product Manager", "Data Analyst"],
  },
  {
    label: "General",
    options: ["Freelancer / Contractor", "Student", "Volunteer", "Other"],
  },
];

/**
 *
 * @param {Object} form
 * @param {function} setFormField
 * @param {Object} errors
 * @returns {JSX.Element}
 * @constructor
 */
export const AboutUserStep = ({ form, setFormField, errors }) => {
  const industryOptions = useMemo(
    () =>
      industries.map((industry, index) => (
        <option
          key={index}
          value={industry}
          selected={form.industry === industry}
        >
          {industry}
        </option>
      )),
    [form]
  );

  const roleOptions = useMemo(
    () =>
      roles.map((roleGroup, index) => (
        <optgroup key={index} label={roleGroup.label}>
          {roleGroup.options.map((role, roleIndex) => (
            <option key={roleIndex} value={role} selected={role === form.role}>
              {role}
            </option>
          ))}
        </optgroup>
      )),
    [form]
  );

  return (
    <div>
      <h3 className="account-title">Let's Get to Know You</h3>
      <p className="text-muted">{introCopy}</p>
      {/* Here you can add a form or other components to collect user information */}
      <form>
        <div className="form-group">
          <label htmlFor="industry">Industry</label>
          <select
            className={classNames("form-control", {
              "is-invalid": errors.industry,
            })}
            id="industry"
            onChange={setFormField("industry")}
          >
            <option value={"-"}>Please choose...</option>
            {industryOptions}
          </select>
          <small className={"text-danger"}>{errors.industry}</small>
          <input
            id={"industryOther"}
            type={"text"}
            value={form.industryOther}
            onChange={setFormField("industryOther")}
            className={classNames("form-control mt-2", {
              "d-none": form.industry !== "Other",
              "is-invalid": errors.industryOther,
            })}
            placeholder={"If 'Other', please specify..."}
          />
          <small className={"text-danger"}>{errors.industryOther}</small>
        </div>
        <div className="form-group">
          <label htmlFor="role">Role</label>
          <select
            className={classNames("form-control", {
              "is-invalid": errors.role,
            })}
            id="role"
            onChange={setFormField("role")}
          >
            <option value={"-"}>Please choose...</option>
            {roleOptions}
          </select>
          <small className={"text-danger"}>{errors.role}</small>
          <input
            id={"roleOther"}
            type={"text"}
            value={form.roleOther}
            onChange={setFormField("roleOther")}
            className={classNames("form-control mt-2", {
              "d-none": form.role !== "Other",
              "is-invalid": errors.roleOther,
            })}
            placeholder={"If 'Other', please specify..."}
          />
          <small className={"text-danger"}>{errors.roleOther}</small>
        </div>
      </form>
      <p className="text-muted">
        <small>
          <sup>1</sup>We only ask for what's needed to personalize your
          experience. We don't sell your info.
        </small>
      </p>
    </div>
  );
};

export default AboutUserStep;
